import enFlag from "../../assets/images/en.svg";
import frFlag from "../../assets/images/fr.svg";

export interface ILanguageFooterItemType {
  imgSrc: string;
  desktopLabel: string;
  label: string;
  value: string;
}

export const LANGUAGE_PICKER_VALUES: ILanguageFooterItemType[] = [
  {
    desktopLabel: "global.language.fr",
    label: "global.language.french",
    value: "fr",
    imgSrc: frFlag,
  },
  {
    desktopLabel: "global.language.en",
    label: "global.language.english",
    value: "en",
    imgSrc: enFlag,
  },
];
